/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface UsersPageAccessPermissions { 
    viewDashboardPage: boolean;
    viewCalendarPage: boolean;
    viewAppointmentListPage: boolean;
    viewPlannerPage: boolean;
    viewAvailabilityPage: boolean;
    viewTherapistListPage: boolean;
    viewTasksPage: boolean;
    viewPatientListPage: boolean;
    viewConfigurationPage: boolean;
    viewConfigurationUsersTab: boolean;
    viewConfigurationPracticesTab: boolean;
    viewTextSnippetsPage: boolean;
    viewPatientFileDocumentationTab: boolean;
    viewPatientFileTreatmentPlanTab: boolean;
    viewPatientFileAppointmentsTab: boolean;
    viewPatientFileTasksTab: boolean;
    viewPatientFileHistoryTab: boolean;
    viewPatientFilePatientDataTab: boolean;
    viewPatientFileCommunicationTab: boolean;
}
export const UsersPageAccessPermissions_viewDashboardPage_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UsersPageAccessPermissions_viewCalendarPage_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UsersPageAccessPermissions_viewAppointmentListPage_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UsersPageAccessPermissions_viewPlannerPage_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UsersPageAccessPermissions_viewAvailabilityPage_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UsersPageAccessPermissions_viewTherapistListPage_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UsersPageAccessPermissions_viewTasksPage_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UsersPageAccessPermissions_viewPatientListPage_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UsersPageAccessPermissions_viewConfigurationPage_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UsersPageAccessPermissions_viewConfigurationUsersTab_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UsersPageAccessPermissions_viewConfigurationPracticesTab_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UsersPageAccessPermissions_viewTextSnippetsPage_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UsersPageAccessPermissions_viewPatientFileDocumentationTab_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UsersPageAccessPermissions_viewPatientFileTreatmentPlanTab_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UsersPageAccessPermissions_viewPatientFileAppointmentsTab_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UsersPageAccessPermissions_viewPatientFileTasksTab_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UsersPageAccessPermissions_viewPatientFileHistoryTab_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UsersPageAccessPermissions_viewPatientFilePatientDataTab_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UsersPageAccessPermissions_viewPatientFileCommunicationTab_Validators: ValidatorFn[] =
    [  Validators.required, ];


